import logo from './profile.jpeg';
import { useLanguage } from './language-context.js';
import content from './content.js';

const SectionHeader = () => {
  const { lang, toggleLang } = useLanguage();
  const t = content[lang].hero;
  const navT = content[lang].nav;
  const cvHref = content[lang].cvHref;

  return (
      <header className="header" id="top">
        <div className="header-utility">
          <ul className="site-nav-links">
            {navT.links.map((link) => (
              <li key={link.href}><a href={link.href}>{link.label}</a></li>
            ))}
          </ul>
          <button type="button" className="lang-toggle" onClick={toggleLang} aria-label="Switch language">
            {navT.toggleLabel}
          </button>
        </div>

        <div className="header-byline">
          <img src={logo} className="profile-thumb" alt={t.name} />
          <div>
            <p className="header-name">{t.name}</p>
            <ul className="header-roles">
              {t.roles.map((role) => <li key={role}>{role}</li>)}
            </ul>
          </div>
        </div>

        <h1 className="header-tagline">{t.tagline}</h1>

        <div className="header-cta">
          <a className="btn btn-primary" href="#experience">{t.ctaExperience}</a>
          <a className="btn btn-ghost" href={cvHref} target="_blank" rel="noopener noreferrer">{t.ctaCV}</a>
        </div>
      </header>
  );
}

export default SectionHeader;
